import type { TelemetryEvent } from './telemetry-models';

/**
 * Base class for all telemetry trackers.
 * Provides consistent lifecycle and logging across tracker implementations.
 */
export abstract class BaseTracker {
  protected _onEvent: (event: TelemetryEvent) => void;
  protected _enabledLogging: boolean;

  constructor(onEvent: (event: TelemetryEvent) => void, enabledLogging = false) {
    this._onEvent = onEvent;
    this._enabledLogging = enabledLogging;
  }

  /** Start tracking - implement to initialize listeners and observers. */
  abstract start(): void;

  /** Stop tracking - implement to cleanup resources and listeners. */
  abstract stop(): void;

  protected _log(...args: unknown[]): void {
    if (this._enabledLogging) {
      // eslint-disable-next-line no-console
      console.log(`[${this.constructor.name}]`, ...args);
    }
  }
}
